function SectionHeader({ kicker, title, children }) {
  return (
    <div className="max-w-2xl">
      {kicker && <p className="eyebrow">{kicker}</p>}
      <h1 className="mt-3 text-4xl font-extrabold tracking-tight text-white sm:text-5xl">{title}</h1>
      {children && <p className="mt-4 text-base leading-7 text-slate-300">{children}</p>}
    </div>
  );
}

export default SectionHeader;
